/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Add an event listener for the custom 'theme:cart:change' event
  document.addEventListener('theme:cart:change', function(event) {
      // Get the cart data from the event's detail property
      var cart = event.detail.cart;
      
      // Check if the cart data is available
      if (cart) {
          // Select all elements that match the specified selector
          var cartStatusElements = document.querySelectorAll('.header__cart__status [data-header-cart-full]');
          
          // Iterate over each selected element and update its innerHTML with the cart item count
          cartStatusElements.forEach(function(element) {
              element.innerHTML = cart.item_count;
          });
      }
  });



})();
